<script>
import axios from 'axios'
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  data(){
    return {
      student: {
        male: 0,
        female: 0
      }
    }
  },
  async mounted(){
    
    let profile = await axios.get('/api/accounts', { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
    let studMale = profile.data.students.filter(stud => {
      return stud.profile.isMale
    })
    let studeFemale = profile.data.students.length - studMale.length
    this.student.male = studMale.length
    this.student.female = studeFemale

    this.renderChart({
      labels: ['Students'],
      datasets: [
        {
          label: 'Male',
          backgroundColor: '#07b5d6',
          data: [this.student.male, 0]
        },
        {
          label: 'Female',
          backgroundColor: '#f87979',
          data: [this.student.female, 0]
        },
      ]
    }, {responsive: true, maintainAspectRatio: false})
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Charts/StudentGender.vue